<p>
  customer-value-expense-partition works!
</p>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value-expense-partition/customer-value-expense-partition.component.html